export function normalizeFilterText(value) {
  return String(value ?? "").trim().toLowerCase();
}

/** True when dropdown is All / Any / empty — that constraint is inactive. */
export function isFilterCleared(selected, openLabels = ["all", "any"]) {
  const normalized = normalizeFilterText(selected);
  return !normalized || openLabels.includes(normalized);
}

/**
 * Match a challenge field to an active filter.
 * Missing/blank challenge fields are non-destructive (still included).
 */
export function matchesOptionalFilter(fieldValue, selected) {
  if (isFilterCleared(selected)) return true;
  const normalizedField = normalizeFilterText(fieldValue);
  if (!normalizedField) return true;
  return normalizedField === normalizeFilterText(selected);
}
